module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_animal_structure_and_function_6-f9d0f51243d610efd14313045222fcc1.jpg";